import React from "react";
import Title from "@streeteasy/design-system/deprecated/Title";
import { bool } from "prop-types";

import ErrorCaught from "src/shared/components/ErrorCaught";

import { shouldShowMobileDesign } from "../../utilities/shouldShowMobileDesign";
import * as S from "./styled";

const FormErrorCaught = ({ isModal }) => {
  const isMobileDesign = shouldShowMobileDesign({
    isModal
  });

  return (
    <S.ErrorContactBox isMobile={isMobileDesign}>
      <ErrorCaught>
        <Title type="secondarySm">
          This contact form won&apos;t load. Please try again.
        </Title>
      </ErrorCaught>
    </S.ErrorContactBox>
  );
};

FormErrorCaught.propTypes = {
  isModal: bool
};

FormErrorCaught.defaultProps = {
  isModal: false
};

export default FormErrorCaught;
